'use strict';

const processInclude = require('base/util');
import giftCardDetail from './giftCard/giftCard';

document.addEventListener('DOMContentLoaded', () => {
    processInclude(giftCardDetail);
});
